/*
  Bleame-style helpers shared by every section.
  - Any link with [data-bl-scroll-buy] (CLAIM OFFER buttons) smoothly scrolls
    to the bundle offers (Kaching) on product pages, or to the variant picker /
    Add to cart button when no bundle app is installed. Off product pages the
    link is followed normally.
*/
(function () {
  if (window.blScrollToBuy) return;

  function stickyOffset() {
    var root = getComputedStyle(document.documentElement);
    var cd = parseFloat(root.getPropertyValue('--bl-cd-h')) || 0;
    var header = document.querySelector('.section-header.shopify-section-header-sticky');
    var hh = header ? header.offsetHeight : 0;
    return cd + hh + 13; /* Bleame: 13px gap under the pinned header */
  }

  /* CLAIM OFFER buttons scroll back up like Bleame's: the bold sentence just
     above the benefit lines lands 13px under the pinned countdown + banner + menu,
     so the sentence, the benefit lines, the bundle offers and the buy button show.
     Targets, in order:
     1. any element marked [data-bl-claim-target] in the product info column
     2. the text block directly above the benefit lines
     3. the benefit lines themselves
     4. the top of the product info column */
  function shown(el) { return el && el.getClientRects().length > 0 && el.getBoundingClientRect().height > 0; }
  function buyTarget() {
    var info = document.querySelector('.bl-main-product .product__info-container') || document.querySelector('.product__info-container');
    if (!info) return null;
    var marked = info.querySelector('[data-bl-claim-target]');
    if (shown(marked)) return marked;
    var benefits = info.querySelector('.emoji-benefits-container');
    if (benefits) {
      var prev = benefits.previousElementSibling;
      while (prev && !shown(prev)) prev = prev.previousElementSibling;
      if (prev && !prev.matches('hr, .bl-pdivider')) return prev;
      if (shown(benefits)) return benefits;
    }
    return info;
  }

  window.blScrollToBuy = function () {
    var el = buyTarget();
    if (!el) return false;
    var top = el.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  };

  /* Bleame: CLAIM OFFER on other pages opens the product page at the offer (…/products/x#offer) */
  function jumpToOffer() {
    if (location.hash !== '#offer') return;
    var go = function () {
      var el = buyTarget(); if (!el) return;
      var top = el.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    };
    go(); setTimeout(go, 300); window.addEventListener('load', go, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', jumpToOffer); else jumpToOffer();

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bl-scroll-buy]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var custom = href && href.charAt(0) !== '#' && a.hasAttribute('data-bl-custom-link');
    if (custom) return;
    if (window.blScrollToBuy()) e.preventDefault();
  });
})();
